import { render } from "./Proprietaire.vue?vue&type=template&id=66aa9bf5"
import script from "./Proprietaire.vue?vue&type=script&lang=js"
export * from "./Proprietaire.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__